import { Component, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import { Subscription } from 'rxjs';
import { RatingService } from '../../../../services/rating.service';
import { SettingsService } from '../../../../services/settings.service';
import { teamMoodsViews } from '../team-mood.component';
import * as uuid from 'uuid';
import { SprintService } from '../../../../services/sprint.service';
import { DatePipe } from '@angular/common';
import { Chart } from 'chart.js';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};


@Component({
  selector: 'app-team-mood-time-range-chart',
  templateUrl: './team-mood-time-range-chart.component.html',
  styleUrls: ['./team-mood-time-range-chart.component.scss']
  })

export class TeamMoodTimeRangeChartComponent implements OnInit, OnDestroy {
  @Output() navigate = new EventEmitter<teamMoodsViews>();
  public projectKey: string;
  public dataSets: any[] = [];
  public dataset: any[] = [];
  public questions: string[] = [];
  public colors: string[] = [];
  public days: any[] = [];
  public votingLabels: any[] = [];
  public votingCounts: number[] = [];
  public chart: Chart;
  public barChart: Chart;
  public endDate: Date;
  public startDate: Date;
  public startSerializedDate = new UntypedFormControl((new Date()));
  public endSerializedDate = new UntypedFormControl((new Date()));

  private event: Subscription[] = [];
  public numberOfQuestions = 0;
  public chartId = 'team-mood-question-line-chart' + uuid.v4();
  public barChartId = 'team-mood-question-bar-chart' + uuid.v4();
  private sprintId: number;

  constructor(
    private settingsService: SettingsService,
    private ratingService: RatingService,
    private sprintService: SprintService) {

  }

  ngOnInit(): void {
    this.event.push(this.settingsService.getUpdateObservable().subscribe(() => {
      this.projectKey = this.settingsService.getProjectName();
      this.loadData();
    }));
    this.projectKey = this.settingsService.getProjectName();
    this.sprintId = this.settingsService.getSprintId(this.projectKey);
    this.sprintService.getSprintDetails(this.projectKey, this.sprintId).subscribe(res => {
      this.endDate = new Date(localStorage.getItem('teamMoodEndDate') || res.endDate);
      this.startDate = new Date(localStorage.getItem('teamMoodStartDate') || res.startDate);
      this.loadData();
    });
    document.getElementById('navigationTimeRangeLeft').addEventListener('click', () => {
      this.navigateToVoting();
    });
    document.getElementById('navigationTimeRangeRight').addEventListener('click', () => {
      this.navigateToTrent();
    });
  }

  startDateChange(new_date) {
    this.startDate = new Date(new_date.value);
    localStorage.setItem('teamMoodStartDate', this.startDate.toString());
    this.loadData();
  }

  endDateChange(new_date) {
    this.endDate = new Date(new_date.value);
    localStorage.setItem('teamMoodEndDate', this.endDate.toString());
    this.loadData();
  }

  loadData() {
    this.questions = [];
    this.dataSets = [];
    this.dataset = [];
    this.votingCounts = [];
    this.votingLabels = [];

    this.ratingService.getRatingsForLine(this.projectKey, this.startDate, this.endDate).subscribe(res => {
      const keys = Object.keys(res['dataset']);
      const len = keys.length;
      this.numberOfQuestions = len;

      for (let i = 0; i < len; i++) {
        this.dataSets.push(res['dataset'][i].data);
        this.questions.push(res['dataset'][i].question.name);
        this.colors.push(res['dataset'][i].question.color);
      }
      this.days = res['label'];
      this.setupDataset();
    });

    this.ratingService.getVoteCountByDay(this.projectKey, this.startDate, this.endDate).subscribe(res => {
      this.votingCounts = res['voteCounts'];
      this.votingLabels = res['label'];
      this.setupBarChart();
    });
  }

  navigateToVoting() {
    this.navigate.emit(teamMoodsViews.showAvg);
  }

  navigateToTrent() {
    this.navigate.emit(teamMoodsViews.showTrends);
  }

  setupDataset() {
    this.dataset = [];

    for (let i = 0; i < this.numberOfQuestions; i++) {
      this.dataset.push({
        label: this.questions[i],
        backgroundColor: this.colors[i],
        borderColor: this.colors[i],
        hitRadius: 10,
        spanGaps: true,
        fill: false,
        data: this.dataSets[i]
      });
    }

    this.setupChart();
  }


  setupChart() {
    if (this.chart) {
      this.chart.destroy();
    }
    if (this.days) {
      const canvas: any = document.getElementById(this.chartId);
      const ctx = canvas.getContext('2d');

      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.days,
          datasets: this.dataset
        },
        options: {
          plugins: {
            legend: {
              display: true
            }
          },
          responsive: true,
          maintainAspectRatio: false,
          // TODO property not valid for chart.js v3, look for alternative
          // borderDashOffset: 1,
          scales: {
            y: {
              min: 1,
              max: 5,
              ticks: { stepSize: 1 }
            }
          }
        }
      });
    }
  }

  setupBarChart() {
    if (this.barChart) {
      this.barChart.destroy();
    }
    const barCanvas: any = document.getElementById(this.barChartId);
    const barCtx = barCanvas.getContext('2d');

    this.barChart = new Chart(barCtx, {
      type: 'bar',
      data: {
        labels: this.votingLabels,
        datasets: [{
          data: this.votingCounts,
          label: 'Votes',
          borderWidth: 1,
          backgroundColor: 'rgb(0,0,255)'
        }]
      },
      options: {
        plugins: {
          legend: {
            display: false
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    });
  }

  ngOnDestroy(): void {
    for (const ev of this.event) {
      ev.unsubscribe();
    }
  }
}
